import React, { Component } from 'react';
import { SingleDatePicker } from 'react-dates';
import moment from 'moment';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import "./ModalItem.scss";
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import ErrorModal from '../../Components/ErrorModal/ErrorModal'

class ModalItem extends Component {

    constructor(props) {
        super(props);


        this.onDateChange = this.onDateChange.bind(this);
        this.calculaDataFinalDigital = this.calculaDataFinalDigital.bind(this);
        this.onFocusChange = this.onFocusChange.bind(this);
        this.habilitaAlterarVigencia = this.habilitaAlterarVigencia.bind(this);
        this.habilitaAlterarAssinante = this.habilitaAlterarAssinante.bind(this);
        this.habilitaAlterarProduto = this.habilitaAlterarProduto.bind(this);
        this.handleCodMembroChange = this.handleCodMembroChange.bind(this);
        this.salvarAlteracoes = this.salvarAlteracoes.bind(this);
        this.buscaMembro = this.buscaMembro.bind(this);
        this.atualizaEdicoes = this.atualizaEdicoes.bind(this);
        this.atualizaProduto = this.atualizaProduto.bind(this);
        this._outsideRange = this._outsideRange.bind(this);
        this.getProdutosTroca = this.getProdutosTroca.bind(this);
        this.ehProdutoAlteravel = this.ehProdutoAlteravel.bind(this);

        this.habilitaBtnSalvarAlteracoes = this.habilitaBtnSalvarAlteracoes.bind(this);

        this.desmembrarItens = this.desmembrarItens.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.isSpecialDate = this.isSpecialDate.bind(this);
        this.periodicDate = this.periodicDate.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            idPedido: this.props.idPedido,
            idItem: this.props.infosModal.idItem,
            codMembroSolicitante: this.props.codMembroSolicitante,
            idUsuario: this.props.infosModal.idUsuario,
            codMembro: this.props.infosModal.codMembro,
            assinante: this.props.infosModal.membro,
            novoAssinante: this.props.infosModal.membro,
            idProduto: this.props.infosModal.idProduto,
            sigla: this.props.infosModal.sigla,
            qtd: this.props.infosModal.qtd,
            periodo: this.props.infosModal.periodo,
            idPeriodo: this.props.infosModal.idPeriodo,
            dtInicio: this.props.infosModal.dtInicio,
            dtFim: this.props.infosModal.dtFim,
            edicaoInicial: this.props.infosModal.edicaoInicial,
            edicaoFinal: this.props.infosModal.edicaoFinal,
            prodDigital: this.props.infosModal.tipoConteudo === "Digital",
            editavel: this.props.infosModal.editavel,
            pedidoCILE: this.props.pedidoCILE,

            codMembroBusca: '',
            buscaRealizada: false,

            isLoading: false,
            habilitaAlterarVigencia: false,
            habilitaAlterarAssinante: false,
            habilitaAlterarProduto: false,
            buscaHabilitada: false,
            alteraVigencia: false,
            alteraVigenciaBM: false,

            date: null,
            endDateBM: null,

            produtosDisponiveisTroca: [],
            novoProduto: null,
            nomeNovoProduto: '',
            produtoAtualizado: false,

            isLoadingDesmembrar: false,
            isLoadingAlterarProduto: false,
            hasError: false,
            errorMessage: '',
            markedDays: [],
        }

        this._phrases = {
            closeDatePicker: "Fechar",
            clearDates: "Limpar datas",
            calendarLabel: "Calendário"
        }

        this._produtosAlteraveis = [
            { idProduto: 1, sigla: 'BS', nome: 'Brasil Seikyo Português', value: 1, label: 'Brasil Seikyo Português', idTroca: 2 },
            { idProduto: 14, sigla: 'BS', nome: 'Brasil Seikyo Português', value: 1, label: 'Brasil Seikyo Português', idTroca: 15 },
            { idProduto: 2, sigla: 'BJ', nome: 'Brasil Seikyo Japonês', value: 2, label: 'Brasil Seikyo Japonês', idTroca: 1 },
            { idProduto: 15, sigla: 'BJ', nome: 'Brasil Seikyo Japonês', value: 2, label: 'Brasil Seikyo Japonês', idTroca: 14 },

        ];
    }

    componentWillMount() {
        if (this.props.infosModal.tipoConteudo !== "Digital" && !this.props.pedidoCILE) {
            axios.get(this.Configurations.apiBasePath + `/edicoes/${this.state.idProduto}`).then(response => {
                this.setState({
                    date: response.data.edicao.dtEntrega,
                    dtProximaEntrega: response.data.edicao.dtEntrega,
                });
                this.periodicDate();
            }).catch(this.handleError);
        }
    }
    isSpecialDate(day) {
        return this.state.markedDays.some((d) => day.isSame(d, "day"));
    }

    periodicDate() {
        axios.get(this.Configurations.apiBasePath + `/edicoes?dtInicial=${moment(this.state.date)}&idProduto=${this.state.idProduto}&idPeriodo=1`)
            .then(response => {

                if (response.data.data.length > 0) {
                    this.setState({
                        markedDays: response.data.data.map(item => moment(item.dtEntrega))
                    });
                }
            })
            .catch(this.handleError);
    }

    habilitaAlterarVigencia() {
        this.setState({
            habilitaAlterarVigencia: !this.state.habilitaAlterarVigencia,
            date: this.state.dtProximaEntrega,
            alteraVigencia: false,
            novaDtEntregaInicial: null
        })
    }

    habilitaAlterarAssinante() {
        this.setState({
            habilitaAlterarAssinante: !this.state.habilitaAlterarAssinante,
            codMembroBusca: '',
            buscaRealizada: false,
            idUsuario: this.props.infosModal.idUsuario,
            alertaBuscaMembro: false
        })
    }

    ehProdutoAlteravel() {
        const prd = this._produtosAlteraveis.find(i => i.idProduto === this.state.idProduto);

        return !!prd
    }

    habilitaAlterarProduto() {
        this.setState({
            habilitaAlterarProduto: !this.state.habilitaAlterarProduto
        }, () => this.getProdutosTroca());
    }

    getProdutosTroca() {
        const prods = this._produtosAlteraveis.filter(produto => {
            const p = produto.idTroca === this.state.idProduto;
            return p;
        });

        this.setState({
            produtosDisponiveisTroca: prods.map(i => ({ label: i.nome, value: i.idProduto }))
        });
    }

    handleCodMembroChange(e) { this.setState({ codMembroBusca: e.target.value.substr(0, 8) }) }

    salvarAlteracoes() {
        this.setState({ assinante: this.state.novoAssinante, isLoadingSalvar: true }, () => {

            const _dtInicioVigencia =
                // (this.state.prodDigital || this.state.pedidoCILE) ?
                (this.state.prodDigital || this.props.pedidoCILE) ?

                    (
                        this.state.date !== null ?
                            moment(this.state.date).toISOString()
                            :
                            moment(this.state.dtInicio).toISOString()
                    ) : (
                        this.state.habilitaAlterarVigencia ?
                            moment(this.state.novaDtEntregaInicial).set('hour', 0).format("YYYY-MM-DD")
                            :
                            moment(this.state.dtInicio).format("YYYY-MM-DD")
                    )

            const _novoPedido = {
                idUsuario: this.state.idUsuario,
                dtInicial: _dtInicioVigencia,
                idPeriodo: this.state.idPeriodo,
                idProduto: this.state.idProduto,
            };
            axios.put(this.Configurations.apiBasePath + `/pedidos/${this.state.idPedido}/itens/${this.state.idItem}`, _novoPedido).then(response => {
                this.props.atualizaPedido();
            }).catch(this.handleError
            ).finally(() => {
                this.props.toggle();
            });
        })
    }

    buscaMembro() {
        if (this.state.codMembroBusca === '') {
            this.setState({ alertaBuscaMembro: true });
        }
        else if (!this.state.buscaRealizada) {
            this.setState({ isLoadingBusca: true })
            axios.get(this.Configurations.apiBasePath + `/membros/${this.state.codMembroBusca}`).then(response => {
                this.setState({
                    buscaRealizada: true,
                    novoAssinante: response.data.data.nome,
                    idUsuario: response.data.data.idUsuario,
                    alertaBuscaMembro: false
                })
            }).catch(this.handleError).finally(() => this.setState({ isLoadingBusca: false }));
        }
        else this.setState({
            buscaRealizada: false,
            novoAssinante: "",
            idUsuario: null
        })
    }

    onDateChange(date) {
        this.setState({
            date,
            alteraVigencia: false
        }, () => {
            if (this.state.prodDigital) {
                this.calculaDataFinalDigital();
            }
        })
    }

    calculaDataFinalDigital() {
        let _meses;
        const _idPer = this.state.idPeriodo;
        switch (_idPer.toString()) {
            case "1":
                _meses = 1;
                break;
            case "2":
                _meses = 3;
                break;
            case "3":
                _meses = 6;
                break;
            case "4":
                _meses = 12;
                break;
            default:
                _meses = 1;
                break;
        }
        this.setState({
            endDateBM: this.state.date !== null ? moment(this.state.date).add("month", _meses) : null,
            alteraVigenciaBM: this.state.date !== null
        })
    }

    onFocusChange(focused) {
    }
    atualizaEdicoes() {
        if (this.state.date === null || this.state.date === "") {
            this.setState({ alteraVigencia: false })
        }
        else {
            const _data = moment(this.state.date).set('hour', 0).format("YYYY-MM-DD");

            axios.get(this.Configurations.apiBasePath + `/edicoes?dtInicial=${_data}&idProduto=${this.state.idProduto}&idPeriodo=${this.state.idPeriodo}`).then(response => {
                this.setState({
                    novaEdicaoInicial: response.data.data[0].edicao,
                    novaDtEntregaInicial: response.data.data[0].dtEntrega,
                    novaEdicaoFinal: response.data.data[1].edicao,
                    novaDtEntregaFinal: response.data.data[1].dtEntrega,
                    alteraVigencia: true
                })
            }).catch(this.handleError);
        }
    }

    handleProduto(o, e) {
        this.setState({
            novoProduto: o.value,
            nomeNovoProduto: o.label
        });
    }

    atualizaProduto() {
        if (this.state.produtoAtualizado) {
            this.setState({ produtoAtualizado: !this.state.produtoAtualizado });
            return;
        }
        if (!this.state.novoProduto) return;

        this.setState({
            idProduto: this.state.novoProduto,
            produtoAtualizado: true
        });
    }

    habilitaBtnSalvarAlteracoes() {
        //MAPA DE KARNAUGH P/ 4 VARIÁVEIS
        // const A = this.state.habilitaAlterarAssinante,
        //     V = this.state.habilitaAlterarVigencia,
        //     B = this.state.buscaRealizada,
        //     E = this.state.alteraVigencia;
        // const _mapa = A * (B * E + !V * B * !E) + !A * V * E;
        // return !_mapa;

        const { buscaRealizada, alteraVigencia, alteraVigenciaBM, produtoAtualizado } = this.state;
        return !(buscaRealizada || alteraVigencia || alteraVigenciaBM || produtoAtualizado);
    }

    _outsideRange(day) {
        // return day.format() < moment().subtract(1, 'month').format();
        return false
    }

    desmembrarItens() {
        this.setState({ isLoadingDesmembrar: true })
        axios.put(this.Configurations.apiBasePath + `/pedidos/${this.state.idPedido}/itens/${this.state.idItem}/desmembrar`).then(response => {
            this.props.atualizaPedido();
        }).catch(this.handleError).finally(() => {
            this.setState({ isLoadingDesmembrar: false })
            this.props.toggle();
        });
    }

    handleError(err) {
        console.log("🚀 ~ file: ModalItem.js:319 ~ ModalItem ~ handleError ~ err:", err.response)
        this.setState({ hasError: true, errorMessage: (err.response && err.response.data && err.response.data.data) ? err.response.data.data.message : 'Erro inesperado.' })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }


    render() {
        return (
            <div className="row modal-item">
                <div className="col-12 py-3">
                    <div className="card">
                        <div className="card-body bg-info text-white">
                            <div className="row pb-2">
                                <div className="col-5">
                                    Assinante: <a className="cursor-pointer text-white" href={`/assinante/${this.state.idUsuario}`}><strong>{this.state.assinante}</strong></a>
                                </div>
                                <div className="col-3">
                                    Período: <strong>{this.state.periodo}</strong>
                                </div>
                            </div>
                            <div className="row align-items-center">
                                <div className="col-5">
                                    Produto: <strong><span className="text-uppercase"> {this.state.qtd} {this.state.sigla}</span></strong>
                                    {this.state.qtd > 1 && !this.state.isLoadingDesmembrar && (<button onClick={this.desmembrarItens} className="mx-2 btn-sm btn-light text-white border-white bg-transparent">desmembrar itens</button>)}
                                    {this.state.qtd > 1 && this.state.isLoadingDesmembrar && (<div className="spinner-border text-primary" role="status" />)}
                                </div>
                                <div className="col-4">
                                    Vigência: <strong>{moment(this.state.dtInicio).format('DD/MM/YYYY')} - {moment(this.state.dtFim).format('DD/MM/YYYY')}</strong>
                                </div>
                                {/* <div className={`${(this.state.prodDigital || this.state.pedidoCILE) ? 'd-none' : 'col-3'}`}> */}
                                <div className={`${(this.state.prodDigital || this.props.pedidoCILE) ? 'd-none' : 'col-3'}`}>

                                    Edições: <strong>{this.state.edicaoInicial} - {this.state.edicaoFinal}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.editavel && (
                    <div className="col-12 botoes-edicao">
                        <div className="row no-gutters">
                            {this.props.flagMembro && (
                                <div className={`col-12 py-4 px-3`}>
                                    <div className="row px-3 align-items-center h-assinante">
                                        <div className="col-4">
                                            <button onClick={this.habilitaAlterarAssinante} className="btn btn-outline-primary">alterar assinante</button>
                                        </div>
                                        {this.state.habilitaAlterarAssinante && (
                                            <div className="col-8">
                                                <div className="row d-flex align-items-center">
                                                    <div className={`${this.state.buscaRealizada ? 'col-8 text-left text-truncate' : 'col-6 text-center'}`}>
                                                        {this.state.buscaRealizada ? (
                                                            <strong className="m-0">{this.state.novoAssinante}</strong>
                                                        ) : (
                                                            <div className="form-group m-0">
                                                                <input id="codMembro" className="form-control" type="number" value={this.state.codMembroBusca.toString().substr(0, 8)} onChange={this.handleCodMembroChange} placeholder="Insira o cód. de membro" />
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="col-3">
                                                        {this.state.isLoadingBusca ? (
                                                            <div className="spinner-border text-primary" role="status" />
                                                        ) : (
                                                            <button onClick={this.buscaMembro} className="btn btn-outline-secondary">{this.state.buscaRealizada ? 'editar' : 'buscar'}</button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                            {this.state.habilitaAlterarAssinante && this.state.alertaBuscaMembro && (
                                <div className="col-12 text-center">
                                    <p className="text-danger">Para prosseguir, por favor insira um cód. de membro válido.</p>
                                </div>
                            )}
                            <div className="col-12 py-4 px-3">
                                <div className={`row px-3 align-items-${this.state.prodDigital ? 'end' : 'center'}`}>
                                    <div className="col-4">
                                        <button onClick={this.habilitaAlterarVigencia} className="btn btn-outline-primary">alterar vigência</button>
                                    </div>
                                    {this.state.habilitaAlterarVigencia && (
                                        <div className="col-8">
                                            {this.state.prodDigital ? (
                                                [
                                                    <div key={1} className={`row`}>
                                                        <div className="col-5">
                                                            Nova Dt. Inicial:
                                                        </div>
                                                        <div className="col-5">
                                                            Nova Dt. Final:
                                                        </div>
                                                    </div>,
                                                    <div key={2} className={`row align-items-center`}>
                                                        <div className="col-5">
                                                            <SingleDatePicker
                                                                date={this.state.date} // momentPropTypes.momentObj or null
                                                                onDateChange={date => this.onDateChange(date)} // PropTypes.func.isRequired
                                                                focused={this.state.focused} // PropTypes.bool
                                                                onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                                                                id="your_unique_id" // PropTypes.string.isRequired,
                                                                orientation="horizontal"
                                                                anchorDirection="right"
                                                                openDirection="down"
                                                                verticalHeight={450}
                                                                numberOfMonths={1}
                                                                small={true}
                                                                phrases={this._phrases}
                                                                placeholder="Data inicial"
                                                                isOutsideRange={this._outsideRange}
                                                            />
                                                        </div>
                                                        <div className="col-5">
                                                            {this.state.endDateBM !== null ? this.state.endDateBM.format("DD/MM/YYYY") : ''}
                                                        </div>
                                                    </div>
                                                ]
                                            ) : (
                                                <div className="row">
                                                    <div className="col-5">
                                                        <SingleDatePicker
                                                            date={this.state.date !== null ? moment(this.state.date) : null} // momentPropTypes.momentObj or null
                                                            // date={this.state.date} // momentPropTypes.momentObj or null
                                                            onDateChange={date => this.onDateChange(date)} // PropTypes.func.isRequired
                                                            focused={this.state.focused} // PropTypes.bool
                                                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                                                            id="your_unique_id" // PropTypes.string.isRequired,
                                                            orientation="horizontal"
                                                            anchorDirection="right"
                                                            openDirection="down"
                                                            verticalHeight={450}
                                                            numberOfMonths={1}
                                                            small={true}
                                                            phrases={this._phrases}
                                                            placeholder="Data inicial"
                                                            isOutsideRange={this._outsideRange}
                                                            renderDayContents={(day) => {
                                                                const text = day.format("D");
                                                                if (this.isSpecialDate(day)) {
                                                                    return (
                                                                        <div
                                                                            className='d-flex justify-content-center align-items-center bg-warning font-weight-bold w-100 h-100'
                                                                        >
                                                                            {text}
                                                                        </div>
                                                                    );
                                                                }
                                                                return text;
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-5 text-left">
                                                        <button disabled={this.state.date === null} onClick={this.atualizaEdicoes} className="btn btn-outline-secondary">atualizar edições</button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                            {(this.state.alteraVigencia && this.state.habilitaAlterarVigencia) && (
                                <div className="col-12 px-3 py-3">
                                    <div className="row align-items-center px-3">
                                        <div className="offset-3 col-3">
                                            <div className="form-group">
                                                Ed. Inicial: {this.state.novaEdicaoInicial}
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="form-group">
                                                Entrega: {moment(this.state.novaDtEntregaInicial).format("DD/MM/YY")}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row align-items-center px-3">
                                        <div className="offset-3 col-3">
                                            <div className="form-group">
                                                Ed. Final: {this.state.novaEdicaoFinal}
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="form-group">
                                                Entrega: {moment(this.state.novaDtEntregaFinal).format("DD/MM/YY")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {this.ehProdutoAlteravel() && (
                                <div className="col-12 py-4 px-3">
                                    <div className="row px-3 align-items-center">
                                        <div className="col-4">
                                            <button onClick={this.habilitaAlterarProduto} className="btn btn-outline-primary">alterar produto</button>
                                        </div>
                                        {this.state.habilitaAlterarProduto && (
                                            <div className="col-8">
                                                <div className="row d-flex align-items-center">
                                                    <div className="col-6">
                                                        {this.state.produtoAtualizado ?
                                                            <strong className="m-0" >{this.state.nomeNovoProduto}</strong>
                                                            :
                                                            <Select
                                                                placeholder="Selecione"
                                                                closeMenuOnSelect={true}
                                                                components={makeAnimated()}
                                                                options={this.state.produtosDisponiveisTroca}
                                                                onChange={(o, e) => this.handleProduto(o, e)}
                                                            />
                                                        }
                                                    </div>
                                                    <div className="col-5 text-left">
                                                        {this.state.isLoadingAlterarProduto ? (
                                                            <div className="spinner-border text-primary" role="status" />
                                                        ) : (
                                                            <button disabled={this.state.date === null} onClick={this.atualizaProduto} className="btn btn-outline-secondary">
                                                                {this.state.produtoAtualizado ? 'editar' : 'alterar produto'}
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                {this.state.editavel ? (
                    <div className="col-12 py-3">
                        <div className="row">
                            <div className="col-6 text-right">
                                <button onClick={this.props.toggle} className="btn btn-outline-secondary">voltar</button>
                            </div>
                            <div className="col-6 text-left">
                                {this.state.isLoadingSalvar ? (
                                    <div className="spinner-border text-primary" role="status" />
                                ) : (
                                    <button disabled={this.habilitaBtnSalvarAlteracoes()} onClick={this.salvarAlteracoes} className="btn btn-success">salvar alterações</button>
                                )}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="col-12 py-3">
                        <div className="row">
                            <div className="col-12 text-center">
                                <p><bold>Este item não é editável</bold></p>
                            </div>
                            <div className="col-12 text-center">
                                <button onClick={this.props.toggle} className="btn btn-outline-secondary">voltar</button>
                            </div>

                        </div>
                    </div>
                )}

                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
            </div >
        )
    }
}

export default ModalItem;